"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkinLegacy_de_de = void 0;
function checkinLegacy_de_de() {
    return {
        "common.dismiss": "OK",
        "common.refresh": "Aktualisieren",
        "common.ok": "OK",
        "common.close": "Schließen",
        "common.upload": "hochladen",
        "common.uploading": "wird hochgeladen...",
        "notifications.notifications": "Benachrichtigungen",
        "notifications.empty": "Hier werden aktuelle Benachrichtigungen angezeigt. Im Moment gibt es nichts neues.",
        "notifications.confirmation.title": "Bestätigung",
        "notifications.warning.title": "Warnung",
        "notifications.error.title": "Fehler",
        "notifications.error.message": "Es ist ein Fehler aufgetreten!",
        "notifications.success.title": "Erfolgreich",
        "loading.app": "Check-In App wird geladen",
        "loading.form": "Formular wird geladen",
        "errors.generic": "Da ist ein Fehler aufgetreten",
        "errors.invalidmail": "Bitte gib eine E-Mail Adresse ein",
        "errors.invalidurl": "Bitte geben Sie eine gültige URL ein",
        "errors.form.missingproperty": "Fehlende Eingabe",
        "errors.http.400": "Die Anfrage konnte nicht verarbeitet werden",
        "errors.http.401": "Sie sind nicht eingeloggt",
        "errors.http.403": "Kein Zugriff auf diese Resource",
        "errors.http.404": "Die angefragte Resource existiert nicht",
        "errors.http.409": "Die Resource existiert bereits",
        "errors.http.500": "Da ging was schief",
        "errors.http.503": "Der Dienst ist im Moment nicht verfügbar",
        "errors.user.email_already_exists": "Diese E-Mail ist bereits registriert.",
        "errors.user.invalid_password_uppercasemissing": "Ungültiges Passwort: Großbuchstabe fehlt",
        "errors.user.invalid_password_lowercasemissing": "Ungültiges Passwort: Kleinbuchstabe fehlt",
        "errors.user.invalid_password_notatleast8characterslong": "Ungültiges Passwort: Bitte mindestens 8 Zeichen eingeben",
        "errors.user.invalid_password_nospecialcharacter": "Ungültiges Passwort: Bitte geben Sie ein Sonderzeichen wie ! ? # oder Leerzeichen ein",
        "errors.user.user_not_found": "Benutzer wurde nicht gefunden",
        "errors.user.invalid_password": "Falsches Passwort",
        "components.list.emptymessage": "Keine Daten gefunden",
        "components.loader.loadingdata": "Daten werden geladen..."
    };
}
exports.checkinLegacy_de_de = checkinLegacy_de_de;
